var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer-layout',[_c('main',{staticClass:"bible"},[_c('data-gathering-header',{attrs:{"title":_vm.$t('data_gatherings.finished').toString(),"breadcrumbs-items":_vm.breadcrumbsItems}}),_vm._v(" "),_c('data-gathering-card-list')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }